module.exports = __webpack_public_path__ + "files/b514621ba56e1ac71924c51579b429cc.svg";